import React from "react";

function ContentPush(pushData = []) {
    const pushValue = pushData.pushData;
    return (
        (pushValue.length) > 0 ?
            pushValue.map((data, index) => (

                (data.pushimage) ? (
                    <div className="content-push" key={index}>
                        <div className="content-push-wrap" key={index}>
                            <div className="content-push-image">
                                <img src={data.pushimage} alt="Special Offer"/>
                                <h2>{data.pushtitle}</h2>
                            </div>
                            <div className="content-push-content">
                                <div className="content-push-description"
                                     dangerouslySetInnerHTML={{__html: data.pushdescription}}>
                                </div>
                                <a href={data.pushlink} className="button">{data.pushcta}</a>
                            </div>
                        </div>
                    </div>
                ) : null

            )) : null

    );

}

export default ContentPush;